// 피드/알림 표시 시점의 * * 액션 묘사 제거.
// 백엔드는 LLM 원문 그대로 저장/반환. 프론트가 노출 시점에만 정리해 보여준다.
// - **굵게**: 별표만 제거, 내용 유지
// - *행동*: 내용 통째 제거
// - 짝 안 맞는 외톨이 별표: 제거
export function stripFeedActions(input: string | null | undefined): string {
  if (!input) return '';
  let s = String(input);
  // 1) **굵게** — 강조 별표만 제거, 내용 유지
  s = s.replace(/\*\*([^*\n]+)\*\*/g, '$1');
  // 2) *행동* — 내용 통째 제거
  s = s.replace(/\*[^*\n]+\*/g, '');
  // 3) 외톨이 별표
  s = s.replace(/\*/g, '');
  // 4) 정리
  s = s.replace(/[ \t]{2,}/g, ' ').trim();
  return s;
}
